import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { SvgIconsModule } from '@ngneat/svg-icon'
import { AdminAuthLayoutComponent } from './auth-layout/auth-layout.component'

@NgModule({
  declarations: [AdminAuthLayoutComponent],
  imports: [CommonModule, RouterModule, SvgIconsModule],
  exports: [AdminAuthLayoutComponent]
})
export class AdminAuthLayoutModule {}
